const satelite = {
  // Planes predefinidos (Gratis / Basico / Profesional / Ilimitado) con sus limites, para el select del alta
  readPlanes: 'satelites/planes',

  // Droop Juedroop
  createSateliteJuedroop: 'satelites/juedroop',
  deleteSateliteJuedroop: 'satelites/juedroop/{{uuid_satelite}}',
  readSatelitesJuedroop: 'satelites/juedroop',
  updateSateliteJuedroop: 'satelites/juedroop/{{uuid_satelite}}',
  uploadSateliteJuedroopImagen: 'satelites/juedroop/{{uuid_satelite}}/imagen',

  // Droop Evaluacion
  createSateliteEvaluacion: 'satelites/evaluacion',
  deleteSateliteEvaluacion: 'satelites/evaluacion/{{uuid_satelite}}',
  readSatelitesEvaluacion: 'satelites/evaluacion',
  updateSateliteEvaluacion: 'satelites/evaluacion/{{uuid_satelite}}',
  uploadSateliteEvaluacionImagen: 'satelites/evaluacion/{{uuid_satelite}}/imagen',

  // Droop Ruleta
  createSateliteRuleta: 'satelites/ruleta',
  deleteSateliteRuleta: 'satelites/ruleta/{{uuid_satelite}}',
  readSatelitesRuleta: 'satelites/ruleta',
  updateSateliteRuleta: 'satelites/ruleta/{{uuid_satelite}}',
  uploadSateliteRuletaImagen: 'satelites/ruleta/{{uuid_satelite}}/imagen',

  // Inteligencia Artificial: planes mensuales (creditos por mes, el consumo vuelve a 0 el dia 1).
  // No confundir con la entidad academiaIa, que es la facturacion de la "Academia IA".
  createSateliteIaMensual: 'satelites/ia-mensual',
  deleteSateliteIaMensual: 'satelites/ia-mensual/{{uuid_satelite}}',
  readSatelitesIaMensual: 'satelites/ia-mensual',
  updateSateliteIaMensual: 'satelites/ia-mensual/{{uuid_satelite}}',
  uploadSateliteIaMensualImagen: 'satelites/ia-mensual/{{uuid_satelite}}/imagen',

  // Inteligencia Artificial: paquetes de creditos (pago unico, no vencen ni se renuevan)
  createSateliteIaCreditos: 'satelites/ia-creditos',
  deleteSateliteIaCreditos: 'satelites/ia-creditos/{{uuid_satelite}}',
  readSatelitesIaCreditos: 'satelites/ia-creditos',
  updateSateliteIaCreditos: 'satelites/ia-creditos/{{uuid_satelite}}',
  uploadSateliteIaCreditosImagen: 'satelites/ia-creditos/{{uuid_satelite}}/imagen',

  // Droops incluidos en un producto
  readProductoSatelites: 'producto/{{uuid_producto}}/satelites',
  updateProductoSatelites: 'producto/{{uuid_producto}}/satelites'
}

export default satelite
